import { BehaviorSubject } from 'rxjs';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Renderer2,
  Input,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
  AfterViewInit,
} from '@angular/core';
import { ILeftMenu, ISideMenu } from '@types-custom/models/ui/side-menu.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ActionService } from '@shared/services/action-service/action.service';

/*
 ** Side menu
 ** Render a side menu that can be toggled and contains items.
 */
@Component({
  selector: 'left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss'],
  // encapsulation: ViewEncapsulation.None,
})
export class LeftMenuComponent implements AfterViewInit {
  // @Input() isExpanded: boolean | undefined | null;
  // @Output() expandedChange: EventEmitter<any> = new EventEmitter();
  @Input() menuItems: ILeftMenu<any>[] | undefined = undefined;
  @Input() activeItem$: BehaviorSubject<any> | undefined;
  // @Input() logoText: string | '' | undefined;
  // @Input() userName: string | null | undefined;

  @ViewChild('leftContainer') menuParent: ElementRef;
  @ViewChildren('sublist') sublistElements: QueryList<ElementRef>;

  panelOpenState = false;
  Icon = Icon;
  opened = false;


  constructor(
    private actionService: ActionService,
    private renderer: Renderer2,
  ) {
  }

  ngAfterViewInit(): void {
    this.updateHeight();
    this.updatePositioning();
  }

  dispatchEvent(dispatcher$: any, event: any): void {
    if (dispatcher$ && event) {
      this.opened = false;
      this.actionService.dispatch(event, dispatcher$);
    }
  }

  updatePositioning() {
    this.sublistElements.forEach((elementRef) => {
      const parent = elementRef.nativeElement.parentElement.parentElement;
      const rect = parent.getBoundingClientRect();
      this.renderer.setStyle(elementRef.nativeElement, 'top', `${rect.y}px`);
      this.renderer.setStyle(elementRef.nativeElement, 'left', `${rect.x + rect.width}px`);
    });
  }

  updateHeight() {
    const rect = this.menuParent.nativeElement.getBoundingClientRect();
    const h = rect.height - (rect.height % rect.width) + rect.width;
    this.renderer.setStyle(this.menuParent.nativeElement, 'maxHeight', `${h}px`);
  }

  handleMouseEnter(ev: MouseEvent,) {
    const prect = this.menuParent.nativeElement.getBoundingClientRect();
    if (ev.y >= prect.y && ev.y <= prect.y + prect.width) {
      this.renderer.setStyle(this.menuParent.nativeElement, 'borderTopRightRadius', `${0}px`);
    }
    if (
      ev.y >
      prect.y + prect.height - prect.width * 1.15 &&
      ev.y <= prect.y + prect.height
    ) {
      this.renderer.setStyle(this.menuParent.nativeElement, 'borderBottomRightRadius', `${0}px`);
    }
  }
  handleMouseLeave(e: any) {
    this.renderer.setStyle(this.menuParent.nativeElement, 'borderTopRightRadius', `var(--br, 10px)`);
    this.renderer.setStyle(this.menuParent.nativeElement, 'borderBottomRightRadius', `var(--br, 10px)`);
  }

  handleToggleMenu() {
    this.opened = !this.opened;
  }
}